export const MealPlanPrint = {
  bindings: {
    pdfs: '<',
    level: '<',
    tooltip: '<',
  },

  template: `
    <div class="dropdown meal-plan-print">
      <button class="btn btn-link dropdown-toggle d-flex align-items-center pr-1"
        data-toggle="dropdown"
        id="meal-plan-print">
        <i class="fa fa-lg icon-print"></i>
        <span class="font-size-small font-size-md-base">
          Print
        </span>
      </button>
      <div class="dropdown-menu dropdown-menu-right"
        aria-labelledby="meal-plan-print">
        <a class="dropdown-item"
          data-toggle="tooltip-print"
          ng-href="{{ $ctrl.pdfs.mealPlan }}?level={{ $ctrl.level }}">
          Meal Plan
        </a>
        <a class="dropdown-item"
          data-toggle="tooltip-print"
          ng-href="{{ $ctrl.pdfs.recipes }}?level={{ $ctrl.level }}">
          Recipes
        </a>
      </div>
    </div>`,

  controller() {
    'ngInject';

    return {
      $onChanges({ tooltip }) {
        if (tooltip && tooltip.currentValue) {
          $('[data-toggle="tooltip-print"]').tooltip('dispose');
          $('[data-toggle="tooltip-print"]').tooltip({
            placement: 'left',
            title: tooltip.currentValue,
          });
        }
      },

      $onDestroy() {
        $('[data-toggle="tooltip-print"]').tooltip('hide');
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/MealPlan/MealPlanPrint.js